<template>
  <div class="">
    <div class="btns flex-s-c">
      <span
        v-for="(item, index) in list"
        :key="index"
        :class="active == index && 'active'"
        @click="changeTab(index)"
        >{{ item.title }}</span
      >
    </div>
    <div
      class="wz-mb-2"
      v-for="(item, index) in list"
      :key="index"
      v-show="active == index"
    >
      <div
        class="
          wz-flex-row wz-align-center
          ant-descriptions-title

        "
        style="flex: none"
      >
        <span style="color: #1890ff" class="margin-r15">▋</span>
        <span class="size18">{{ item.title }}</span>
        <!-- <span
          class="wz-ml-2"
          style="font-size=12px;color: rgba(255,255,255,0.5)"
          >{{ item.time ? "上次编辑时间：" + item.time : "" }}</span
        > -->
      </div>
      <div
        class="margin-t30"
        style="margin-bottom: 70px"
        v-for="(tebInfo, tabIdx) in item.indexList"
        :key="tabIdx"
      >
        <div class="wz-flex-row wz-align-center margin-b30">
          <div
            class="
              wz-flex-row wz-align-center
              ant-descriptions-title

            "
            style="flex: none"
          >
            <span class="size16">{{ tebInfo.indexType }}</span>
          </div>
          <div class="wz-flex-1 wz-flex-row wz-justify-end">
            <span class="history" @click="lsClick(tebInfo, item.tableName)"
              >历史记录</span
            >
          </div>
        </div>
        <div class="wz-mt-1" v-if="tebInfo.keyList">
          <div class="wz-flex-row wz-flex-wrap">
            <div
              class="wz-flex-row wz-align-center"
              style="width: 50%;border-bottom: 1px solid #414974;background: #429df1;"
              v-for="(keyInfo, keyIdx) in tebInfo.keyList"
              :key="keyIdx"
            >
              <div class="bgs">
                <div class="size14 txt-white">{{ keyInfo.name }}</div>
                <div class="size12 txt-white margin-t10" style="opacity: 0.6" v-if="keyInfo.updateTime">
                  更新时间&nbsp;{{moment(keyInfo.updateTime).format("MM/DD HH:mm")}}
                </div>
              </div>
              <div
                class="bgss flex-s-c"
                style="height: 100%; padding: 0 25px"
              >
                <div class="flex-s-c width-full" v-if="!keyInfo.edit">
                  <div class="wz-flex-1">{{ keyInfo.value }}</div>
                  <!-- <EditOutlined
                    v-if="[1,4,5].includes(loginInfo.type)"
                    @click="clickEdit(index, tabIdx, keyIdx)"
                  /> -->
                </div>
                <div class="flex-s-c width-full" v-else>
                  <input
                    class="flex-1 input margin-r15 pad-x15 pad-y10"
                    v-model="
                      list[index].indexList[tabIdx].keyList[keyIdx].putVal
                    "
                    placeholder="请输入"
                    type="text"
                  />
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <a-modal
      v-model:visible="visible"
      :title="indexType"
      @ok="oks"
      @cancel="oks"
      width="800px"
      wrapClassName="full-modal"
    >
      <div class="clear">
        <div class="fl">
          <a-select
            ref="select"
            v-model:value="value1"
            style="width: 120px"
            @focus="focus"
            @change="handleChange"
          >
            <a-select-option
              v-for="item in historyList"
              :key="item.key"
              :value="item.key"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </div>
        <div class="rangeSelect fr colorW">
          <a-month-picker
            :value="month"
            v-if="range === 2"
            class="ml15"
            style="width: 200px !important; display: inline-block"
            v-model:value="value3"
            :format="monthFormat"
            @change="onChange1"
          />
          <a-week-picker
            v-else
            :value="week"
            format="YYYY年-第wo"
            class="ml15"
            style="width: 200px !important; display: inline-block"


            @change="onChange"
          />
          <span
            class="ml15"
            :class="range == 2 ? 'rangeSelectActive' : ''"
            @click="dateChange(2)"
            >月</span
          >
          <span
            class="ml15"
            :class="range == 1 ? 'rangeSelectActive' : ''"
            @click="dateChange(1)"
            >周</span
          >
        </div>
      </div>
      <!-- <a-card> -->
      <div class="wz-flex-row wz-align-end wz-mb-1" style="color: #ffffff">
        <!-- <h3 style="color:#ffffff">体重</h3>
          <h2 style="color:#ffffff" class="wz-ml-1">50.0 kg</h2> -->
      </div>
      <!-- <a-badge color="gold" text="数据时间 09/13 18:00" /> -->
      <div v-if="shows" id="lsjl" style="width: 100%; height: 400px"></div>
      <a-empty v-else />
      <!-- </a-card> -->
    </a-modal>
  </div>
</template>
<script>
// import { getHealthData, addHealthData, getHistory } from "@/common/api/api.js";
import moment from "moment";
import { mapState } from "vuex";
import * as API_Member from "@/api/member/member";
// import { formatDate } from "@/common/js/wzPublic.js";
export default {
  props: ['type'],
  components: {},
  inject: ["getId"],
  computed: {
    ...mapState(["loginInfo"]),
    moment: () => moment,
    id() {
      return this.getId();
    },
  },
  data() {
    return {
      active: 0,
      lsjlEcharts: "",
      historyList: [],
      week: moment(),
      month: moment(),
      indexType: "",
      range: 2,
      lsjlOptions: {
        xAxis: {
          type: "category",
          data: ["08/07", "08/06", "08/05", "08/04", "08/03", "08/02", "08/01"],
          axisLabel: {
            show: true,
            textStyle: {
              color: "#ffffff", //更改坐标轴文字颜色
              fontSize: 14, //更改坐标轴文字大小
            },
          },
        },
        yAxis: {
          min: "dataMin",
          max: "dataMax",
          type: "value",
          axisLabel: {
            show: true,
            textStyle: {
              color: "#ffffff", //更改坐标轴文字颜色
              fontSize: 14, //更改坐标轴文字大小
            },
          },
        },
        series: [
          {
            data: [80, 80, 75, 78, 77, 69, 70],
            type: "line",
            symbol: "circle", // 设置折点为实心圆
            symbolSize: 6, // 折点大小
            itemStyle: {
              // 折点颜色
              color: "#108ee9",
            },
            lineStyle: {
              // 设置线条颜色
              color: "#108ee9",
            },
          },
        ],
      },
    //   userId: this.$store.state.loginInfo.id, //用户id
      visible: false,
      value1: "",
      shows: false,
      list: [],
      startDate: moment().day(1).hours(0).minute(0).seconds(0).valueOf(),
      endDate: moment().day(7).hours(23).minute(59).seconds(59).valueOf(),
      tableName: "",
    };
  },
  mounted() {
    // this.initlsjlEcharts()
    this.getList();
  },
  watch: {
    historyList(v) {
      if (v.length) {
        // 当数据存在 ，echart显示第一个选择
        this.value1 = v[0].key;
        this.ecahrtsxl();
      }
    },
  },
  methods: {
    changeTab(index) {
      this.active = index;
    },
    oks() {
      this.week = this.month = moment();
      this.range = 1;
      (this.visible = false), (this.value1 = "");
      this.historyList = [];
      // month:moment(),
    },
    handleChange(e) {
      this.ecahrtsxl();
    },
    // 改变周月
    dateChange(e) {
      this.range = e;
      if (e === 1) {
        this.onChange(moment());
      } else {
        this.onChange1(moment());
      }
    },
    // 改变周
    onChange(weekData) {
      this.week = weekData;

      const startDate = (this.startDate = moment(weekData).isoWeekday(1).startOf("day").day(1).valueOf()); // 周一日期
      const endDate = (this.endDate = moment(weekData).isoWeekday(1).endOf("day").day(7).valueOf()); // 周日日期
      this.getHistoricalData(startDate, endDate);
    },
    onChange1(weekData) {

      this.month = weekData;
      this.startDate = moment(weekData).startOf("month").valueOf();
      this.endDate = moment(weekData).endOf("month").valueOf();
      this.getHistoricalData(this.startDate, this.endDate);
    },
    // 获取历史数据
    async getHistoricalData(start, end) {
      let obj = {
        start,
        end,
        indexType: this.indexType,
        memberId: this.$route.query.id || this.loginInfo.id,
        table: this.tableName,
      };
      console.log(obj);
      const data = await getHistory(obj);
      // ,({data})=>{

      if (!data.data.length) {
        this.initlsjlEcharts([], []);
        this.shows = false;
        return;
      }
      this.shows = true;
      this.historyList = data.data;
      //   console.log(datas,xdatas)
    },
    // 渲染数据
    ecahrtsxl() {
      let dataList = this.historyList.filter(
        (item) => item.key === this.value1
      )[0];

      let datas = dataList.list.map((item) => item.value);

      let xdatas = dataList.list.map((item) =>
        moment(item.date).format("YYYY-MM-DD")
      );
      console.log(datas,xdatas)
      setTimeout(() => {
        this.initlsjlEcharts(xdatas, datas);
      }, 0);
    },
    lsClick({ keyList, indexType }, tableName) {
      this.historyList = [];
      //  this.historyList=keyList
      this.tableName = tableName;
      this.indexType = indexType;
      this.value1 = "";
      this.visible = true;
      this.startDate = moment().startOf("month").valueOf();
      this.endDate = moment().endOf("month").valueOf();
      this.getHistoricalData(this.startDate, this.endDate);
      //  setTimeout(() => {
      //   this.initlsjlEcharts()
      //  }, 10);
    },
    // 初始化实时体重图表
    initlsjlEcharts(xData, yData) {
      this.lsjlEcharts = this.$echarts.init(document.getElementById("lsjl"));

      // 初始化图表数据
      this.setlsjlEcharts(xData, yData);
    },
    // 设置实时体重图表数据
    setlsjlEcharts(xData, yData) {
      // let xData = [],
      //   yData = [];
      // list.forEach((item) => {
      //   xData.push(item.dataTime);
      //   yData.push(item.value);
      // });
      this.lsjlOptions.xAxis.data = xData;
      this.lsjlOptions.series[0].data = yData;

      console.log(this.lsjlOptions);
      // 绘制图表
      this.lsjlEcharts.setOption(this.lsjlOptions);
    },
    async getList() {
      console.log(this.type, 'type');
      const getData = await API_Member.getHealthData({
        type: this.type,
        memberId: this.$route.query.id || this.loginInfo.id,
      });
      if (getData.code == 200) {
        if (getData.data.length > 0) {
          getData.data.forEach((item) => {
            if (item.time) {
              let time = String(item.time);
              item.time =
                time.substr(0, 4) +
                "/" +
                time.substr(4, 2) +
                "/" +
                time.substr(6, 2) +
                " " +
                time.substr(8, 2) +
                ":" +
                time.substr(10, 2);
            }
            if (item.indexList) {
              item.indexList.forEach((idxInfo) => {
                if (idxInfo.keyList) {
                  idxInfo.keyList.forEach((keyInfo) => {
                    keyInfo.putVal = keyInfo.value; // 添加初始参数编辑参数
                    keyInfo.edit = false; // 添加初始参数是否编辑
                  });
                }
              });
            }
          });
        }
        console.log("getData.data--", getData.data);
        this.list = getData.data;
      }
    },
    // 点击编辑
    clickEdit(index, idx, kdx) {
      this.list[index].indexList[idx].keyList[kdx].putVal =
        this.list[index].indexList[idx].keyList[kdx].value;
      this.list[index].indexList[idx].keyList[kdx].edit = true;
    },
    // 取消编辑
    closeEdit(index, idx, kdx) {
      this.list[index].indexList[idx].keyList[kdx].edit = false;
    },
    // 确认编辑
    async finishEdit(index, idx, kdx) {
      if (
        !this.list[index].indexList[idx].keyList[kdx].putVal ||
        this.list[index].indexList[idx].keyList[kdx].putVal ==
          this.list[index].indexList[idx].keyList[kdx].value
      ) {
        this.$message.error("未作出修改！");
        return false;
      }
      const getData = await addHealthData({
        memberId: this.$route.query.id * 1 || this.loginInfo.id,
        tableName: this.list[index].tableName,
        indexType: this.list[index].indexList[idx].indexType,
        fieldName: this.list[index].indexList[idx].keyList[kdx].name,
        field: this.list[index].indexList[idx].keyList[kdx].key,
        value: this.list[index].indexList[idx].keyList[kdx].putVal,
      });
      if (getData.code == 200) {
        this.$message.success("编辑成功！");
        // this.list[index].indexList[idx].keyList[kdx].value = this.list[index].indexList[idx].keyList[kdx].putVal;
        this.closeEdit(index, idx, kdx);

        this.getList();
      }
    },
  },
};
</script>
<style scoped lang="less">
.input {
  color: #999;
  // background: #282f54;
  outline: none;
  border: none;
}
.rangeSelect {
  margin-left: -5%;
}
.rangeSelect span {
  width: 50px;
  text-align: center;
  border: 1px solid rgba(228, 228, 228, 1);
  cursor: pointer;
  border-radius: 3px;
  line-height: 50px;
  float: right;
 color:#ffffff
}
.selectDate {
  border-color: rgba(64, 158, 255, 1) !important;
  color: rgba(64, 158, 255, 1);
}
.rangeSelectActive {
  border-color: rgba(64, 158, 255, 1) !important;
  color: #ffffff !important;
  background: rgba(64, 158, 255, 1);
}
.bgs {
  // background: #429df1 !important;
  flex-shrink: 0;
  width: 20%;
  padding: 25px 10px;
}
.bgss {
  flex: 1;
  // background: #141937;
  overflow: hidden;
}
::v-deep .ant-empty-description {
  color: #ffffff;
}
.btns {
  margin: 30px 0 40px;
  span {
    font-size: 14px;
    // background: #282f54;
    border-radius: 4px;
    white-space: nowrap;
    margin-right: 15px;
    padding: 10px;
    // border: 1px solid rgba(40, 47, 84);
    color: #ffffff;
  }
  span.active {
    background: none;
    border: 1px solid rgba(24, 144, 255, 0.8);
    color: #1890ff;
  }
}
.history {
  border: 1px solid rgba(24, 144, 255, 0.8);
  color: #1890ff;
  font-size: 14px;
  background: none;
  border-radius: 4px;
  white-space: nowrap;
  margin-right: 15px;
  padding: 5px;
}
</style>
